<script>
import {mapActions, mapGetters} from 'vuex'
import {alpha_num, has_value} from '@/utils/validators'
import {ReqOps, ReqState} from '@/utils/vars'

export default {
  computed: {
    ...mapGetters([
      'connection',
      'req_state'
    ]),
    is_connected() {
      return this.connection.connected &&
        this.connection.app_id === this.app.id
    },
    is_connecting() {
      return this.req_state[ReqOps.Connect] === ReqState.Request
    },
    is_saving() {
      return this.req_state[ReqOps.SaveApp] === ReqState.Request
    }
  },
  data() {
    return {
      alpha_num,
      error_alert: false,
      form_data: null,
      form_data_template: {
        description: '',
        repo: '',
        title: 'Untitled'
      },
      has_value,
      success_alert: false,
      window_idx: 0
    }
  },
  methods: {
    ...mapActions([
      'connect',
      'delete_app',
      'load_apps',
      'save_app'
    ]),
    on_connect_click(id) {
      this.connect(id)
    },
    on_delete_click(id) {
      this.delete_app(id)
      this.$emit('delete')
    },
    on_components_btn_click(idx) {
      this.window_idx = 0
      this.$emit('select', this.idx)
    },
    on_edit_cancel_click() {
      this.window_idx = 0
    },
    on_save_btn_click(app) {
      const form = this.$refs.form
      if(form && form.validate()) {
        this.save_app({...app, ...this.form_data})
          .then(() => {
            this.error_alert = false
            this.success_alert = true
            setTimeout(() => {
              this.success_alert = false
            }, 3000)
          }).catch(() => {
            this.error_alert = true
            this.success_alert = false
            setTimeout(() => {
              this.error_alert = false
            }, 3000)
          })
      }
    },
    on_settings_btn_click(idx) {
      this.window_idx = 1
      this.$emit('select', this.idx)
      this.form_data = {
        description: this.app.description,
        private: this.app.private,
        repo: this.app.repo,
        title: this.app.title
      }
    }
  },
  name: 'app-panel-item',
  props: {
    app: {type: Object, default: () => null},
    idx: {type: Number, default: () => 0},
    is_open: {type: Boolean, default: () => false}
  }
}
</script>

<template>
<v-expansion-panel class='item'>
  <v-expansion-panel-header  disable-icon-rotate>
    <div class='d-flex flex-column'>
      <div class='title font-weight-semibold primary--text'>{{app.title}}</div>
    </div>
    <template v-slot:actions>
      <div class='d-flex align-center'>
        <v-btn @click='on_components_btn_click(idx)' @click.native.stop icon>
          <v-icon small>fa-chart-area</v-icon>
        </v-btn>
        <v-btn @click='on_settings_btn_click(idx)' @click.native.stop
          class='mr-2' icon>
          <v-icon small>fa-cog</v-icon>
        </v-btn>
        <v-btn v-if='is_open'  @click='on_connect_click(app.id)'
          @click.native.stop :loading='is_connecting' outlined rounded small>
          <v-icon :color='is_connected ? `success` : `error`' left x-small>
            fa-circle
          </v-icon>
          <span>{{is_connected ? `Connected` : `Connect`}}</span>
        </v-btn>
        <v-icon v-else :color='is_connected ? `success` : `error`' left x-small>
          fa-circle
        </v-icon>
      </div>
    </template>
  </v-expansion-panel-header>
  <v-expansion-panel-content>
    <v-window v-model='window_idx'>
      <v-window-item>
        <candela-component-list v-if='connection.app_id === app.id'/>
        <div v-else class='d-flex justify-center pa-4'>
          <span>Connect to this app to view components</span>
        </div>
      </v-window-item>
      <v-window-item class='pa-4'>
        <v-alert v-show='success_alert' class='body-2' color='success' border='left'
          transition='fade-transition' colored-border dismissible text>
          <span>Your app has been saved!</span>
        </v-alert>
        <v-alert v-show='error_alert' color='error' border='left'
          transition='fade-transition' colored-border dense dismissible text>
          <span>There was an error saving your app.</span>
        </v-alert>

        <v-form v-if='form_data' ref='form'>
          <v-text-field v-model='form_data.title'
            :rules='[alpha_num, has_value]' label='App Name' dense outlined/>
          <v-textarea v-model='form_data.description'
            label='Description' dense outlined/>
          <v-text-field label='App ID' :value='app.id'  dense disabled outlined/>
        </v-form>
        <div class='d-flex justify-space-between'>
          <v-btn @click='on_delete_click(app.id)' class='mr-2'
            color='red' small text>
            <v-icon left x-small>fa-trash</v-icon>
            <span>Delete App</span>
          </v-btn>
          <div>
            <v-btn @click='on_edit_cancel_click' class='mr-2' color='secondary'
              outlined small>
              <v-icon left x-small>fa-times</v-icon>
              <span>Cancel</span>
            </v-btn>
            <v-btn @click='on_save_btn_click(app)' color='primary' outlined small
              :loading='is_saving'>
              <v-icon left x-small>fa-save</v-icon>
              <span>Update</span>
            </v-btn>
          </div>
        </div>
      </v-window-item>
    </v-window>
  </v-expansion-panel-content>
</v-expansion-panel>
</template>
